export const shopPath = (shop) => {
  if (!shop) return "/shops";
  const slug = shop.subdomain || shop.shop_slug;
  return slug ? `/fioristi/${slug}` : `/shops/${shop.id || shop.shop_id}`;
};
export const shopUrlLabel = (slug) => `flowerlive.it/fioristi/${slug}`;
